<template>
  <div>
    <CircleButton class="back-button" @clickButton="$emit('clickButton')">
      <div class="back-icon">
        <img src="../../../assets/images/_parts/other/retry.svg" alt="" />
      </div>
      <p class="back-text">やり直す</p>
    </CircleButton>
  </div>
</template>
<script>
import CircleButton from "../../ui/buttons/CircleButton.vue";
export default {
  name: "BackButton",
  components: { CircleButton },
};
</script>
<style lang="scss" scoped>
.back-button {
  width: 80px;

  .back-icon {
    width: 19px;
    height: 21px;

    & > img {
      object-fit: contain;
    }
  }

  .back-text {
    line-height: 1;
    font-family: "Noto Sans JP";
    font-size: 14px;
    color: #fff;
    font-weight: 500;
    margin-top: 4px;
    letter-spacing: initial;
  }

  @include media() {
    width: vw(67);
    .back-icon {
      width: vw(16);
      height: vw(18);
    }
    .back-text {
      font-size: vw(12);
      margin-top: vw(5);
      letter-spacing: 0.1vw;
    }
  }
}
</style>
